export const property = {
  createProperty: {
    title: "Criar propriedade",
    of: "de",
  },
  sections: {
    details: "Detalhes da propriedade",
    presentation: "Apresentação",
    rooms: "Quartos",
    bookingSettings: "Configurações de reserva",
    checkinSettings: "Configurações de check-in",
    extras: "Serviços adicionais",
  },

  menu: {
    name: "Nome",
    location: "Localização",
    logo: "Logo da propriedade",
    capacity: "Capacidade",
    services: "Serviços da propriedade",
    description: "Descrição",

    roomTypes: "Tipos de quarto",
    roomManagement: "Gerenciar quartos",

    imagesRooms: "Imagens dos quartos",
    imagesProperty: "Imagens da propriedade",

    priceCurrency: "Preço e moeda",
    rates: "Tarifas",
    maintenance: "Manutenção da propriedade",

    scheduling: "Agendamento",

    sesHospedajes: "SES Hospedagens",

    smartLocks: "Fechaduras inteligentes",
    experiences: "Experiências e serviços",
    chatbot: "ChatBot com IA",
  },

  firstStep: {
    heading: "Qual é o nome da sua acomodação?",
    subheading:
      "Atraia hóspedes com um nome marcante que destaque o melhor do seu lugar.",
    fieldLabel: "O nome da sua acomodação",
    placeholder: "ex.: Praia Paraíso",
    internalNameLabel: "Nome interno",
    internalNamePlaceholder: "Nome de referência interno para a acomodação",
  },

  locationStep: {
    heading: "Onde fica a sua acomodação?",
    subheading:
      "Informe o endereço exato para que os hóspedes encontrem seu lugar facilmente.",
    countryLabel: "País",
    addressLabel: "Endereço completo",
    addressPlaceholder: "ex.: Rua Sierpes, 25, Sevilha",
    cityLabel: "Cidade",
    cityPlaceholder: "ex.: Sevilha",
    zipLabel: "Código postal",
    zipPlaceholder: "ex.: 41004",
  },
  logoStep: {
    heading: "Qual é o logo da sua acomodação?",
    description:
      "Adicione o logo da sua acomodação para parecer mais profissional e ser mais fácil de identificar. Formatos permitidos: PNG, JPG, SVG.",
    currentLogoTitle: "Logo atual:",
    currentLogoAlt: "Logo atual",
  },

  roomTypeStep: {
    heading: "Informações do quarto",
    description:
      "Insira um nome para este tipo de quarto, como “Quarto Duplo” ou “Suíte Familiar”. Isso ajudará você a identificá-lo facilmente no calendário e nos canais de reserva. No seu painel, você poderá adicionar seus outros tipos de quarto",
    basicInfoTitle: "Informações básicas",
    nameLabel: "Nome",
    namePlaceholder: "Nome personalizado",
    occupancyTitle: "Capacidade do quarto",
    adultsLabel: "Adultos",
    childrenLabel: "Crianças",
    infantsLabel: "Bebês",
  },

  hotelRoomsStep: {
    heading: "Atribua os quartos físicos da sua propriedade",
    description:
      "Crie os quartos reais que estarão disponíveis para reservas, como “101 - Quarto Duplo” ou “302 - Suíte Familiar”. Isso ajudará a organizá-los no calendário e a gerenciar a disponibilidade com facilidade.",
    roomTypeLabel: "Tipo de quarto",
    roomNameLabel: "Nome do quarto",
    roomNamePlaceholder: "Nome personalizado",
    roomCodeLabel: "Número ou código do quarto",
    roomCodePlaceholder: "Opcional",
  },

  capacityStep: {
    heading: "Compartilhe detalhes essenciais sobre o seu lugar",
    description:
      "Especifique o número de hóspedes, quartos e banheiros. Observe que quartos e banheiros são considerados privativos por padrão. Se forem compartilhados, você pode atualizar isso depois nos detalhes da sua propriedade.",
    labels: {
      guests: "Hóspedes",
      bedrooms: "Quartos",
      bathrooms: "Banheiros",
    },
  },

  servicesStep: {
    heading: "Mostre aos hóspedes o que o seu lugar oferece",
    subtitle:
      "Selecione as comodidades disponíveis. Você pode adicionar mais depois pelo CMS.",
    services: {
      oven: "Forno e fogão",
      pets_allowed: "Animais permitidos",
      wifi: "Internet Wi-Fi",
      essentials: "Itens essenciais",
      washing_machine: "Máquina de lavar",
      air_conditioning: "Ar-condicionado",
      heating: "Aquecimento central",
      parking: "Vaga de estacionamento",
      children_allowed: "Crianças permitidas",
      refrigerator: "Geladeira",
    },
  },

  priceStep: {
    heading: "Qual é o preço por noite?",
    subtitle:
      "Defina o preço padrão para criar a primeira tarifa por noite, além da moeda da sua propriedade.",
    labels: {
      pricePerNight: "Tarifa por noite",
      currency: "Moeda",
    },
    placeholders: {
      priceExample: "ex.: 100",
    },
    requiredAsterisk: "*",
  },

  descriptionStep: {
    heading: "Como você descreveria o seu lugar?",
    subtitle:
      "Atraia hóspedes com uma breve descrição da sua propriedade. Destaque as comodidades disponíveis e os pontos de interesse próximos.",
    placeholders: {
      example:
        "ex.: Um loft estiloso com vista para a cidade—perfeito para trabalhar, fazer compras e absorver o clima urbano.",
    },
    inspiration: "Precisa de inspiração?",
    buttons: {
      useAI: "Usar IA",
      generating: "Gerando...",
    },
    errors: {
      generate:
        "Ocorreu um erro ao gerar a descrição. Tente novamente.",
    },
  },
  navigation: {
    save: "Salvar",
    next: "Próximo",
  },
  common: {
    success: "Sucesso",
    error: "Erro",
    cancel: "Cancelar",
    save: "Salvar",
  },

  images: {
    heading: "Imagens da propriedade",
    subtitleHotel:
      "Adicione as fotos dos seus quartos para que possam ser usadas na sua página de reservas diretas na web.",
    subtitleApt:
      "Adicione as fotos da sua propriedade para que possam ser usadas na sua página de reservas diretas na web.",

    loadRoomsError: "Não foi possível carregar os quartos",
    uploadSuccess: "Imagens válidas enviadas com sucesso",
    uploadErrorGeneric: "Erro ao enviar imagens",

    deleteConfirmMessage: "Tem certeza de que deseja excluir esta imagem?",
    deleteConfirmHeader: "Confirmação",
    deleteAccept: "Excluir",
    deleteReject: "Cancelar",
    deleteSuccess: "Imagem excluída com sucesso",
    deleteError: "Erro ao excluir imagem",

    setMainSuccess: "Imagem principal atualizada",
    setMainError: "Erro ao definir a imagem principal",

    invalidFilesTitle: "Arquivos inválidos",

    mainBadge: "Principal",
  },

  dropzone: {
    prompt: "Arraste imagens aqui ou clique para selecionar",
    formatHint: "Formatos: JPEG, PNG, GIF.",
    uploading: "Enviando imagens... {progress}%",
    invalidHeader: "Alguns arquivos não atendem aos requisitos:",
    reasonType: "tipo inválido",
    reasonSize: "excede o limite de tamanho",
    and: "e",
  },

  checkin: {
    heading: "Quando os links de check-in serão enviados?",
    subtitle:
      "Programe o envio automático do link de check-in para seus hóspedes.",

    options: {
      same_day: { amount: "No mesmo dia", text: "do check-in" },
      24: { amount: "24 horas", text: "antes do check-in" },
      48: { amount: "48 horas", text: "antes do check-in" },
      72: { amount: "72 horas", text: "antes do check-in" },
      disabled: { amount: "Desativar", text: "Vou enviar manualmente" },
    },
    recommended: "Recomendado",

    details: {
      sameDay: "6h do mesmo dia",
      previousNight: "18h da noite anterior",
      corresponding: "18h correspondente",
    },

    confirm: {
      message: "Tem certeza de que deseja alterar o agendamento do check-in?",
      header: "Confirmar alteração",
      accept: "Alterar agendamento",
      reject: "Cancelar",
    },

    toasts: {
      loadError: {
        title: "Erro",
        body: "Falha ao carregar as configurações de check-in.",
      },
      saveSuccess: {
        title: "Configurações atualizadas",
        body: "Processo concluído com sucesso",
      },
    },

    messages: {
      disabled: "O envio automático está desativado. Deve ser enviado manualmente.",
      same_day: "Os check-ins serão enviados às 6h do mesmo dia do check-in",
      exactly24: "Os check-ins serão enviados às 18h na noite anterior ao check-in",
      // If you don't have ICU plural, use a generic message
      daysBefore:
        "Os check-ins serão enviados às 18h, {days} dia(s) antes do check-in",
    },
  },

  police: {
    header: "Registrar os dados da autoridade competente",
    toasts: {
      saveSuccess: {
        title: "Ação concluída com sucesso",
        body: "Os dados da autoridade foram salvos com sucesso",
      },
    },
    errors: {
      lessorRequired: {
        title: "Erro, campo do locador",
        body: "O código do locador é obrigatório",
      },
      establishmentRequired: {
        title: "Erro, campo do estabelecimento",
        body: "O código do estabelecimento é obrigatório",
      },
    },
  },

  identity: {
    title: "Loja do check-in",
    subtitle: "No check-in, o hóspede recebe por WhatsApp um link com o que pode juntar à estadia.",
    propertyLabel: "Propriedade:",
    toggle: {
      title: "Ativar verificação de identidade",
      hint: "Quando ativada, os hóspedes precisarão verificar sua identidade.",
      on: "ON",
      off: "OFF",
    },
    config: {
      whatTitle: "O que você pede ao hóspede?",
      whatHint: "Escolha as fotos que ele terá de tirar. Pelo menos uma.",
      frontTitle: "Documento pela frente",
      frontDesc: "O lado com a foto. É o que se compara com a selfie.",
      backTitle: "Documento pelo verso",
      backDesc:
        "O verso, onde costumam ficar o endereço e a zona de leitura.",
      selfieTitle: "Selfie na hora",
      selfieDesc: "Uma foto do rosto, tirada na hora com a câmera.",
      compareOn: "Compara-se o rosto do documento com a selfie.",
      compareOff:
        "A foto apenas fica guardada: sem documento e selfie não há rostos para comparar.",
      requiredTitle: "E se os rostos não coincidirem…",
      noTitle: "Pode continuar",
      noDesc:
        "Termina o check-in mesmo assim e você vê marcado no painel.",
      yesTitle: "Não pode continuar",
      yesDesc:
        "Não poderá terminar o check-in até dar certo. Pode tentar quantas vezes precisar.",
      lockedHint:
        "Para exigir isso são necessários o documento pela frente e a selfie.",
      summaryTitle: "O hóspede verá",
      needOne: "Você tem de pedir pelo menos uma foto.",
      noStorage:
        "Neste país não guardamos as fotos de identidade, apenas o resultado. Sem comparação facial não ficará registo nenhum.",
      serviceDown:
        "Se o nosso serviço de comparação falhar, o hóspede é deixado continuar e você vê marcado: ninguém fica na porta por uma avaria nossa.",
    },
    toasts: {
      updated: "Configurações de verificação de identidade atualizadas com sucesso",
      updateError: "Erro ao atualizar as configurações de verificação de identidade",
    },
  },

  guestReviews: {
    subtitle:
      "Insira a URL do site de avaliações que deseja configurar para que seus hóspedes possam deixar seus comentários, seja no Google ou em outro site de avaliações que você usa. Isso ajuda a melhorar a visibilidade e a reputação da acomodação.",
    enableTitle: "Ativar avaliações de hóspedes",
  },

  smartLocks: {
    title: "Fechaduras inteligentes",
    subtitle:
      "Conecte-se a fechaduras inteligentes compatíveis e esqueça as chaves físicas. Gere e envie códigos de acesso automaticamente—sem trabalho manual, 100% seguro.",
    propertyLabel: "Propriedade",
    compatibleTitle: "Fechaduras inteligentes compatíveis",
    andManyMore: "e muitas outras...",

    enableTitle: "Ativar fechadura inteligente",
    enableHelp:
      "Envie o código de acesso aos seus hóspedes assim que o check-in for concluído, exatamente no horário de check-in selecionado.",

    configTitle: "Configuração",
    configSubtitle: "Defina suas preferências de envio do código de acesso",

    deliveryLabel: "Horário de envio do código de acesso",
    deliveryDesc:
      "Escolha o horário em que o código de acesso será enviado ao seu hóspede no dia da reserva.",
    saveTimeBtn: "Salvar horário",
    saveTimeLoading: "Salvando...",

    accessTypeLabel: "Tipo de código de acesso",

    static: {
      title: "Código estático",
      desc: "Use o mesmo código para todos os hóspedes",
    },
    dynamic: {
      title: "Código dinâmico",
      desc: "Gere códigos únicos por reserva",
      soon: "Em breve",
    },

    masterCodeLabel: "Código de acesso mestre",
    masterCodePlaceholder: "Insira seu código de acesso mestre",
    saveCodeBtn: "Salvar código",
    saveCodeLoading: "Salvando...",

    masterCodeHelp:
      "Este código será enviado automaticamente aos hóspedes no horário especificado no dia do check-in.",

    dynamicInfo: {
      title: "Códigos de acesso dinâmicos",
      desc: "Este recurso premium gerará automaticamente códigos de acesso únicos para cada reserva, proporcionando mais segurança e uma melhor experiência para o hóspede. Disponível em breve!",
    },

    support: {
      title: "Precisa de ajuda com a integração?",
      desc: "Integramos com todas as principais marcas de fechaduras inteligentes. Nossa equipe técnica ajudará você a configurar o seu modelo específico.",
      cta: "Falar com o suporte",
    },

    errors: {
      emptyKey: "Insira uma chave de acesso",
    },

    toasts: {
      updateSuccess: "Configurações da fechadura inteligente atualizadas com sucesso",
      updateError: "Erro ao atualizar as configurações da fechadura inteligente",
      timeSuccess: "Horário de envio atualizado com sucesso",
      timeError: "Erro ao atualizar o horário de envio",
      keySuccess: "Chave de acesso salva com sucesso",
      keyError: "Erro ao salvar a chave de acesso",
    },
  },

  services: {
    listMovedHelp: "A lista de serviços é uma só para toda a conta: escreve-se uma vez e marca-se em que anúncios é oferecida.",
    listMovedLink: "Ir para Serviços e experiências",
    title: "Experiências e serviços",
    subtitle: "Gerencie os serviços adicionais da sua propriedade.",
    enableTitle: "Ativar loja de experiências e serviços",
    enableHelp:
      "Promova todas as experiências e serviços adicionais da sua propriedade. Os hóspedes recebem um link do WhatsApp no check-in.",
    storeType: {
      title: "Tipo de loja",
      internal: {
        title: "Loja interna",
        desc: "Gerencie seus serviços diretamente na plataforma",
      },
      external: {
        title: "Loja externa",
        desc: "Redirecione os hóspedes para a sua loja externa",
      },
    },
    externalConfig: {
      title: "Configuração da loja externa",
      guestMessageLabel: "Mensagem para os hóspedes",
      guestMessagePlaceholder:
        "Ex.: Descubra nossos serviços adicionais e experiências exclusivas em nossa loja online...",
      guestMessageHelp:
        "Mensagem exibida aos hóspedes após o check-in (máx. 200 caracteres)",
      urlLabel: "A URL da sua loja externa",
      urlPlaceholder: "https://your-external-store.com",
      urlHelp: "URL completa onde os hóspedes podem reservar experiências e serviços",
      noteTitle: "Observação:",
      noteText:
        "Os hóspedes receberão esta mensagem personalizada com o link após concluir o check-in.",
    },
    addBtn: "Adicionar",
    delete: {
      title: "Excluir serviço?",
      text: "Esta ação não pode ser desfeita",
      confirm: "Excluir",
      cancel: "Cancelar",
    },
    toasts: {
      stateUpdated: "Status do serviço atualizado",
      deleted: "Serviço excluído com sucesso",
      storeUpdated: "Configurações de experiências e serviços atualizadas com sucesso",
      storeError: "Erro ao atualizar as configurações de experiências e serviços",
      configUpdated: "Configuração da loja atualizada com sucesso",
      configError: "Erro ao atualizar a configuração da loja",
    },
  },
  bot: {
    enableTitle: "Ativar assistente virtual",
    enableHelp: "Automatize o atendimento aos hóspedes com respostas rápidas no WhatsApp.",
  },

  rooms: {
    heading: "Tipos de quarto",
    subtitle: "Gerencie os tipos de quarto da sua propriedade.",
    addTypeCta: "Adicionar tipo de quarto",
    adultsCapacity: "Capacidade de adultos: {count}",
    emptyList: "Nenhum quarto cadastrado.",

    deleteConfirmHeader: "Confirmar exclusão",
    deleteConfirmMessage:
      "Tem certeza de que deseja excluir este quarto? Esta ação não pode ser desfeita.",
    deleteConfirmAccept: "Sim, excluir",
    deleteConfirmReject: "Cancelar",

    deleteSuccess: "Quarto excluído com sucesso.",
    deleteError: "Erro ao excluir o quarto.",
  },

  roomMgmt: {
    remaining: "Disponíveis: {count}",
    heading: "Gerenciar quartos",
    subtitle: "Atribua quartos individuais aos tipos cadastrados.",
    totalRooms: "Total de quartos: {count}",

    typeLabel: "Tipo",
    codeLabel: "Código",
    nameLabel: "Nome",
    descLabel: "Descrição",

    selectPlaceholder: "Selecionar",
    codePlaceholder: "Código",
    namePlaceholder: "Nome do quarto",
    descPlaceholder: "Descrição do quarto",

    addBtn: "Adicionar",

    planLimitTitle: "Limite atingido",
    planLimitMsg:
      "Você atingiu o número máximo de quartos permitido pelo seu plano. Faça upgrade da sua assinatura para adicionar mais.",

    loadTypesError: "Não foi possível carregar os tipos de quarto",
    loadRoomsError: "Não foi possível carregar os quartos existentes",

    saveSuccessTitle: "Sucesso",
    saveSuccessMsg: "Quartos salvos com sucesso",
    saveError: "Não foi possível salvar os quartos",

    deleteSuccess: "Quarto excluído com sucesso.",
    deleteError: "Erro ao excluir o quarto.",
    formIncompleteError:
      "Preencha o tipo e o nome de quarto para todos os quartos.",
  },

  rates: {
    heading: "Tarifas",
    subtitleHotel: "Gerencie as tarifas das suas acomodações.",
    subtitleSingle: "Gerencie as tarifas da sua acomodação.",
    adultsCapacity: "Capacidade de adultos: {count}",
    roomsCount: "Quartos {count}",
    singleUnit: "Unidade de acomodação",

    table: {
      name: "Nome",
      occupancy: "Hóspedes",
      priceTaxIncl: "Preço (IMPOSTO INCLUÍDO)",
      actions: "Ações",
    },

    addRate: "Adicionar tarifa",
    emptyList: "Nenhuma tarifa cadastrada.",

    deleteConfirmHeader: "Confirmar exclusão",
    deleteConfirmMessage:
      "Tem certeza de que deseja excluir esta tarifa? Esta ação não pode ser desfeita.",
    deleteConfirmAccept: "Sim, excluir",
    deleteConfirmReject: "Cancelar",

    deleteSuccess: "Tarifa excluída com sucesso.",
    deleteError: "Erro ao excluir a tarifa.",
  },
};

export default property;
